var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.formOption.busy } },
    [
      _c(
        "a-form",
        {
          attrs: {
            form: _vm.form,
            "label-col": { span: 12 },
            "wrapper-col": { span: 12 },
          },
        },
        [
          _c("div", { staticClass: "form_title" }, [_vm._v("海报设置")]),
          _c("div", { staticStyle: { display: "flex" } }, [
            _c(
              "div",
              {
                staticClass: "bg",
                style: {
                  backgroundImage:
                    "url(" +
                    _vm.api.temp.FILE_PATH +
                    _vm.fissionPosterImg +
                    ")",
                },
              },
              [
                _vm.hd.show
                  ? _c(
                      "VueDragResize",
                      {
                        ref: "VueDragResize",
                        attrs: {
                          isActive: true,
                          w: _vm.hd.width,
                          h: _vm.hd.height,
                          x: _vm.hd.xaxis,
                          y: _vm.hd.yaxis,
                          parentW: 375,
                          parentH: 667,
                          parentLimitation: true,
                        },
                        on: { resizing: _vm.resize, dragging: _vm.resize },
                      },
                      [
                        _c("a-avatar", {
                          staticClass: "hd",
                          attrs: { src: require("@/assets/img/moren.png") },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.name.show
                  ? _c(
                      "VueDragResize",
                      {
                        ref: "VueDragResize1",
                        attrs: {
                          isActive: true,
                          w: _vm.name.width,
                          h: _vm.name.height,
                          x: _vm.name.xaxis,
                          y: _vm.name.yaxis,
                          parentW: 375,
                          parentH: 667,
                          parentLimitation: true,
                        },
                        on: { resizing: _vm.resize2, dragging: _vm.resize2 },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "name",
                            style: {
                              color: _vm.name.color,
                              fontSize: _vm.staffNameSize + "px",
                            },
                          },
                          [_vm._v("昵称")]
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm.ewm.show
                  ? _c(
                      "VueDragResize",
                      {
                        ref: "VueDragResize2",
                        attrs: {
                          isActive: true,
                          w: _vm.ewm.width,
                          h: _vm.ewm.height,
                          x: _vm.ewm.xaxis,
                          y: _vm.ewm.yaxis,
                          parentW: 375,
                          parentH: 667,
                          parentLimitation: true,
                        },
                        on: { resizing: _vm.resize1, dragging: _vm.resize1 },
                      },
                      [
                        _c("img", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            src: require("@/assets/img/ewm.jpg"),
                            alt: "",
                          },
                        }),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            ),
            _c("div", { staticClass: "form" }, [
              _c(
                "div",
                { staticClass: "item" },
                [
                  _c("span", [_vm._v("*")]),
                  _vm._v(" 上传海报背景图 "),
                  _c("uploader", {
                    attrs: {
                      num: 1,
                      accept: "image/*",
                      url: _vm.api.temp.UPLOAD_PATH,
                    },
                    model: {
                      value: _vm.fissionPosterImg,
                      callback: function ($$v) {
                        _vm.fissionPosterImg = $$v
                      },
                      expression: "fissionPosterImg",
                    },
                  }),
                  _vm._v(
                    " 只能上传jpg、jpeg、png文件，建议尺寸：750px*1280px，不超过5M "
                  ),
                ],
                1
              ),
              _c("div", { staticClass: "keys" }, [
                _c("p", [_vm._v("展示字段")]),
                _c("ul", [
                  _c(
                    "li",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: false,
                          expression: "false",
                        },
                      ],
                    },
                    [
                      _vm._v("裂变二维码 "),
                      _c("a-switch", {
                        attrs: { defaultChecked: _vm.ewm.show },
                        on: {
                          click: function ($event) {
                            _vm.ewm.show = !_vm.ewm.show
                            _vm.$forceUpdate()
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "li",
                    [
                      _vm._v("分享人头像 "),
                      _c("a-switch", {
                        attrs: { defaultChecked: _vm.hd.show },
                        on: {
                          click: function ($event) {
                            _vm.hd.show = !_vm.hd.show
                            _vm.$forceUpdate()
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "li",
                    [
                      _vm._v("分享人昵称 "),
                      _c("a-switch", {
                        attrs: { defaultChecked: _vm.name.show },
                        on: {
                          click: function ($event) {
                            _vm.name.show = !_vm.name.show
                            _vm.$forceUpdate()
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "li",
                    [
                      _vm._v("昵称颜色 "),
                      _c("colorPicker", {
                        staticStyle: { border: "1px solid #000" },
                        on: { change: _vm.headleChangeColor },
                        model: {
                          value: _vm.name.color,
                          callback: function ($$v) {
                            _vm.$set(_vm.name, "color", $$v)
                          },
                          expression: "name.color",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "li",
                    [
                      _vm._v(" 文字大小 "),
                      _c(
                        "a-radio-group",
                        {
                          model: {
                            value: _vm.staffNameSize,
                            callback: function ($$v) {
                              _vm.staffNameSize = $$v
                            },
                            expression: "staffNameSize",
                          },
                        },
                        [
                          _c("a-radio-button", { attrs: { value: 16 } }, [
                            _vm._v(" 小 "),
                          ]),
                          _c("a-radio-button", { attrs: { value: 20 } }, [
                            _vm._v(" 中 "),
                          ]),
                          _c("a-radio-button", { attrs: { value: 24 } }, [
                            _vm._v(" 大 "),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
              _c("div", [
                _vm._v(
                  " 海报上的展示字段可拖动调整位置，点击后拖动边框调整大小 "
                ),
              ]),
            ]),
          ]),
        ]
      ),
      _c(
        "a-space",
        { staticClass: "a-form-btn-box" },
        [
          _c("a-button", { on: { click: _vm.lastStep } }, [_vm._v("上一步")]),
          _c(
            "a-button",
            { attrs: { type: "primary" }, on: { click: _vm.submit } },
            [_vm._v("下一步")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }